import { z } from 'zod';

export const AGENCY_TASK_PRIORITIES = ['none', 'low', 'medium', 'high', 'urgent'] as const;
export const agencyTaskPrioritySchema = z.enum(AGENCY_TASK_PRIORITIES);
export type AgencyTaskPriority = z.infer<typeof agencyTaskPrioritySchema>;

export const agencyTaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable().optional(),
  dueDate: z.coerce.date().nullable().optional(),
  completedAt: z.coerce.date().nullable().optional(),
  priority: agencyTaskPrioritySchema,
  agencyId: z.string(),
  userId: z.string().nullable().optional(),
  clientId: z.string().nullable().optional(),
  postId: z.string().nullable().optional(),
  assignedToClient: z.boolean().optional(),
  isPrivate: z.boolean().optional(),
  blockedBy: z.array(z.string()).nullable().optional(),
  blockedByPostApproval: z.boolean().optional(),
  order: z.number().optional(),
  aiSuggestion: z.boolean().nullable().optional(),
  recurringTemplateId: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type AgencyTaskSchema = z.infer<typeof agencyTaskSchema>;
